
import { ref, defineComponent } from "vue";
import { prepareQueryToSearch } from "../../utils/functions";
export default defineComponent({
  name: "SearchInput",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup(prp, ctx) {
    const inputFocused = ref(false);
    const query = ref("");

    const handleSearch = () => {
      ctx.emit("search", prepareQueryToSearch(query.value));
    };

    return {
      inputFocused,
      handleSearch,
      query,
    };
  },
});
